import { render, staticRenderFns } from "./ManejoCreditosOtorgados.vue?vue&type=template&id=68ddfb9c"
import script from "./ManejoCreditosOtorgados.vue?vue&type=script&lang=js"
export * from "./ManejoCreditosOtorgados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports